/**
 * Labstep
 *
 * @module components/FilterPost/NewIndex/Device/Form
 * @desc Filter Device form
 */

import { withActiveGroup } from 'labstep-web/containers/ActiveGroup';
import { ParamsStateContextProvider } from 'labstep-web/contexts/params-state';
import { SearchSelectContainer as SearchSelect } from 'labstep-web/core/Select/Search';
import { Device } from 'labstep-web/models/device.model';
import { PostFilterDevice } from 'labstep-web/services/postFilter/filters/device';
import type React from 'react';
import type { IFilterPostNewIndexDeviceFormProps } from './types';

const FilterPostNewIndexDeviceForm: React.FC<
  IFilterPostNewIndexDeviceFormProps
> = ({ addPostFilter, onDone, activeGroup }) => {
  if (!activeGroup) {
    return null;
  }

  return (
    <ParamsStateContextProvider value={{}}>
      <SearchSelect
        entityName={Device.entityName}
        isClearable
        params={{
          group_id: activeGroup?.id,
        }}
        onChange={(selectedOption) => {
          if (addPostFilter) {
            addPostFilter(
              PostFilterDevice.getNode([selectedOption?.guid]),
            );
          }
          onDone();
        }}
      />
    </ParamsStateContextProvider>
  );
};

export default withActiveGroup(FilterPostNewIndexDeviceForm);
